<div class="cads-field" [class.cads-field--bare]="config().bare">
  @if (config().label) {
    <label
      class="cads-field__label"
      [class.cads-field__label--error]="_hasError()"
      [attr.for]="config().controlId"
    >
      {{ config().label }}
      @if (config().required) {
        <span class="cads-field__required" aria-hidden="true">*</span>
      }
    </label>
  }

  <div
    [class.cads-field__projected]="config().bare === true"
    [class.cads-field__control]="config().bare !== true"
    [class.cads-field__control--focused]="config().bare !== true && focused() && !_hasError()"
    [class.cads-field__control--error]="config().bare !== true && _hasError()"
  >
    <ng-content />
  </div>

  @if (_showCaption()) {
    @if (_showProjectedCaption()) {
      <div [id]="_captionId()" class="cads-field__caption cads-field__caption--projected">
        <ng-content select="[cadsFieldCaption]" />
      </div>
    } @else {
      <p
        [id]="_captionId()"
        class="cads-field__caption"
        [class.cads-field__caption--error]="_hasError()"
        [attr.role]="_hasError() ? 'alert' : null"
      >
        {{ _captionText() }}
      </p>
    }
  }
</div>
